import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import CasesCreateEnquiryModal from './CasesCreateEnquiryModal'
import { createEnquiry } from 'features/Cases/Cases.actions'
import { get, flow } from 'lodash'

const formName = 'createEnquiry'

const stateToProps = ({ form, billing }) => ({
  formData: get(form, [formName, 'values'], {}),
  bills: billing.bills,
})

const dispatchToProps = {
  createEnquiry,
}

export default flow(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(CasesCreateEnquiryModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateEnquiryModal/CasesCreateEnquiryModal.container.js